import { MedicalTermInput } from '../../lib/types/models/medical-terms/medical-term-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateMedicalTerm(data: UpdateInput<MedicalTermInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.medicalTerms.update.url, { id })).patch(rest)
}
